import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PageElementSpec } from '../../../classes/page-element-spec';
import { DynamicPageElementComponent } from '../../section-blocks/dynamic-page-element/dynamic-page-element.component';
import { BrandService } from '../../../services/brand/brand.service';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
import { WalPageService } from '../../../services/session/wal-page.service';
import { ISessionDetails } from '../../../interfaces/session-details';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-subaccounts-card-deck',
    standalone: true,
    imports: [DynamicPageElementComponent],
    templateUrl: './subaccounts-card-deck.component.html',
    styleUrl: './subaccounts-card-deck.component.css'
})
export class SubaccountsCardDeckComponent  implements OnInit {

  private readonly router = inject(Router);
  private readonly dataExchangeService = inject(DataExchangeService);
  private readonly brandService  = inject(BrandService);
  private readonly walPageService = inject(WalPageService);
  private readonly logger = inject(NGXLogger);

  accountDataPoints: PageElementSpec<string>[] = [];
  subaccounts: any[] = [];
  subaccountType!: string;

  region!: string;
  brandImageUrl!: string;

  // pageElementSpec

  ngOnInit() {
    this.region = this.dataExchangeService.getRegion();
    let session: ISessionDetails = this.dataExchangeService.getSession();

    if (this.region && session) {
      // this.setCustomizations(this.region, session.brandCode || '');

      let region: string = this.dataExchangeService.getRegion();
      let sessionDetails: ISessionDetails = this.dataExchangeService.getSession();
      let serialNumber: string = '';
      // Find out the serial number
      if (sessionDetails.options) {
          const options: Map<string, string> = new Map(Object.entries(sessionDetails.options));
          if (options) {
              if (options.has("serialNumber")) {
                  serialNumber = options.get('serialNumber') || '';
              }
          }
      }
      this.walPageService.getSubaccounts(region, sessionDetails.walPageUuid, sessionDetails.brandCode || '', serialNumber)
      .subscribe({
        next: (response) => {
          if (response) {
              console.log('response', response);
              this.subaccounts = response;
          }
        },
        error: (error) => {
          },
        complete: () => {
        }
      });

    }
  }

  public setCustomizations(region: string, brandCode: string) {

    this.brandService.getBrandLogoUrl(region, brandCode)
    .subscribe({
      next: (response) => {
        if (response) {
          // console.log('setCustomizations', response);
          this.brandImageUrl = response;
        }
      },
      error: (error) => {
        console.log('error', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });

  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }

}


  // private getSubaccounts() {
  //   this.subaccountType = "INVOICE";
  //   this.subaccounts =
  //   [
  //     {
  //         "subAccountId": "2006564371",
  //         "pageElements": [
  //             {
  //                 "label": "INVOICE NUMBER",
  //                 "value": "2006564371",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "ORIGINAL INVOICE AMOUNT",
  //                 "value": "1203.66",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "TOTAL INVOICE DUE",
  //                 "value": "1203.66",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "INVOICE DATE",
  //                 "value": "08/01/2024",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "INVOICE DUE DATE",
  //                 "value": "08/22/2024",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "INVOICE SOURCE",
  //                 "value": "BC",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "INVOICE TYPE",
  //                 "value": "Insured",
  //                 "key": ""
  //             }
  //         ]
  //     },
  //     {
  //       "subAccountId": "2006564373",
  //         "pageElements": [
  //             {
  //                 "label": "INVOICE NUMBER",
  //                 "value": "2006564373",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "ORIGINAL INVOICE AMOUNT",
  //                 "value": "1503.66",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "TOTAL INVOICE DUE",
  //                 "value": "1218.66",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "INVOICE DATE",
  //                 "value": "09/01/2024",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "INVOICE DUE DATE",
  //                 "value": "09/22/2024",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "INVOICE SOURCE",
  //                 "value": "BC",
  //                 "key": ""
  //             },
  //             {
  //                 "label": "INVOICE TYPE",
  //                 "value": "Insured",
  //                 "key": ""
  //             }
  //         ]
  //     }

  //   ]
  // }

